import { Box, LinkProps, Typography } from '@mui/material';
import React from 'react';
import { LinkStyled } from './Header.styled';
import { RobotoFont } from '../../styles/fonts';
import Image from 'next/image';

export interface IHeader extends LinkProps {
  path?: string;
  icon?: string;
  title: string;
  withIcons?: boolean;
  forHeader?: boolean;
  forMobileHeader?: boolean;
  marginBottom?: string;
}

export const NavLink = ({
  path = '/',
  withIcons,
  icon,
  title,
  onClick,
  onMouseOver,
  onMouseLeave,
  forHeader,
  forMobileHeader,
  marginBottom,
}: IHeader) => {
  return forHeader ? (
    <LinkStyled
      href={path}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      style={{ padding: '11px 6px 9px', marginBottom: marginBottom ? marginBottom : '10px' }}
    >
      {withIcons ? <Box>{icon}</Box> : null}
      <Typography
        variant='button'
        style={{
          fontWeight: 360,
          letterSpacing: '0px',
          color: '#333435',
          fontFamily: RobotoFont.style.fontFamily,
          fontStretch: '75%',
          transform: 'scaleX(0.75)',
        }}
      >
        {title}
      </Typography>
    </LinkStyled>
  ) : (
    <LinkStyled href={path} onClick={onClick} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}>
      {forMobileHeader ? (
        <>
          {withIcons && icon ? (
            <Box style={{ minWidth: '24px', display: 'flex', position: 'relative', minHeight: '19px' }}>
              <Image src={icon} style={{ display: 'block', margin: '0 auto' }} alt='header' height={24} width={24} />
            </Box>
          ) : null}
          <Typography
            variant='h4'
            style={{ fontSize: '22px', lineHeight: '26px', letterSpacing: '1px', marginLeft: '18px' }}
          >
            {title}
          </Typography>
        </>
      ) : (
        <>
          {withIcons ? <Box>{icon}</Box> : null}
          <Typography variant='button'>{title}</Typography>
        </>
      )}
    </LinkStyled>
  );
};
